<template>
  <b-modal
    size="lg"
    id="store-promo-modal-ppc"
    :hide-header="false"
    :hide-footer="true"
    v-if="promotion.coupons.length > 0"
    centered
  >
    <CouponCarousel
      :coupons="promotion.coupons"
      :selectedSlide="slide"
    ></CouponCarousel>
  </b-modal>
</template>
<!-- @TODO - Vertically Center Coupon Modal on Page -->
<script>
import CouponCarousel from "@/components/partials/CouponCarouselSingleView.vue";
export default {
  components: {
    CouponCarousel,
  },
  props: {
    slide: Number,
    promotion: Object,
  },
  data: () => {
    return {
      sliding: null,
      currentSlide: 0,
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    hideModal() {
      this.$store.commit("CloseAllModals");
    },
    toggleQuote() {
      //this modal close
    },
    toggleAppointment() {
      //this modal close
    },
  },
};
</script>
<style>
#store-promo-modal-ppc .modal-dialog {
  transform: translate(0, 0);
  height: 100vh;
}
#store-promo-modal-ppc .modal-header {
  background: white;
  width: 100%;
}
#store-promo-modal-ppc .modal-content {
  display: flex;
  flex-wrap: wrap;
}
#store-promo-modal-ppc .modal-body {
  width: 90%;
  padding: 0;
  margin: auto;
  overflow: hidden;
  padding-bottom: 25px;
}
.modal-open #store-promo-modal {
  overflow-y: hidden;
}
.modal-open #store-promo-modal-ppc.fade {
  opacity: 1 !important;
}
.btn-appointment-quote {
  background-color: #ffe300;
  text-transform: uppercase;
  font-weight: bold;
}
.btn-appointment-quote:hover {
  color: white;
}
.modal-header .close {
  top: 0px;
  right: 0;
  padding: 0;
  font-size: 40px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
}
.modal-header {
  border-bottom: 0px solid transparent;
}
body.modal-open {
  overflow-y: hidden;
}
</style>
